import { Component } from "@angular/core";
import { RouterOutlet } from "@angular/router";

@Component({
    selector: 'app-layout-with-navbar',
    templateUrl: './layout-with-navbar.component.html',
    styleUrls: ['./layout-with-navbar.component.scss'],
    imports: [RouterOutlet]
})
export class LayoutWithNavbarComponent {
}
